{
  "encounter_creatures": {
    "key": "encounter_creature_id",
    "persisted_types": ["creature", "lair"],
    "owner": "encounter_id",
    "prefix": "encounter_creature",
    "required": [
      "encounter_creature_id",
      "encounter_id",
      "item_id",
      "item_type",
      "team"
    ],
    "updates": [
      "encounter_creature_deleted",
      "creature_number",
      "encounter_creature_dead",
      "v_current",
      "v_temp",
      "aps",
      "aps_total",
      "reaction",
      "weapon_attack",
      "head_attack",
      "movement_pct",
      "movement_rev"
    ],
    "columns": [
      "encounter_creature_private",
      "encounter_id",
      "encounter_creature_id",
      "encounter_creature_name",
      "encounter_creature_flavor_text",
      "encounter_creature_personality",
      "encounter_creature_quirks",
      "encounter_creature_motivations",
      "encounter_creature_secrets",
      "encounter_creature_tactics",
      "encounter_creature_gm_notes",
      "item_id",
      "item_type",
      "encounter_creature_monster_template_id",
      "team",
      "controller_encounter_creature_id",
      "summon_type",
      "creature_number",
      "creature_initiative",
      "v_current",
      "v_max",
      "v_temp",
      "v_max_temp",
      "encounter_creature_dead",
      "encounter_creature_deleted",
      "spell_list_prepared",
      "aps",
      "aps_total",
      "weapon_attack",
      "head_attack",
      "reaction",
      "mana",
      "luck",
      "spirit",
      "hunger_meter_current",
      "thirst_meter_current",
      "x_pos",
      "y_pos",
      "z_pos",
      "movement_pct",
      "preferred_speed_type",
      "encounter_creature_presentation_pic_id",
      "encounter_creature_thumbnail_pic_id",
      "gender",
      "body_appearance",
      "merchant_favor",
      "voice_id",
      "combat_id",
      "lair_dc",
      "appearance"
    ],
    "numbers": [
      "encounter_creature_private",
      "creature_number",
      "creature_initiative",
      "v_current",
      "v_max",
      "v_temp",
      "v_max_temp",
      "encounter_creature_dead",
      "encounter_creature_deleted",
      "spell_list_prepared",
      "aps",
      "aps_total",
      "weapon_attack",
      "head_attack",
      "reaction",
      "mana",
      "luck",
      "spirit",
      "hunger_meter_current",
      "thirst_meter_current",
      "movement_pct",
      "x_pos",
      "y_pos",
      "z_pos",
      "merchant_favor",
      "lair_dc",
      "movement_rev"
    ],
    "values": {
      "item_type": [
        "creature",
        "lair"
      ]
    },
    "references": [
      "controller_encounter_creature_id"
    ],
    "decimals": [
      "x_pos",
      "y_pos",
      "z_pos"
    ],
    "before": [
      "encounter_creature_private",
      "encounter_id",
      "encounter_creature_id",
      "encounter_creature_name",
      "encounter_creature_flavor_text",
      "encounter_creature_personality",
      "encounter_creature_quirks",
      "encounter_creature_motivations",
      "encounter_creature_secrets",
      "encounter_creature_tactics",
      "encounter_creature_gm_notes",
      "item_id",
      "item_type",
      "encounter_creature_monster_template_id",
      "team",
      "controller_encounter_creature_id",
      "summon_type",
      "creature_number",
      "creature_initiative",
      "v_current",
      "v_max",
      "v_temp",
      "v_max_temp",
      "encounter_creature_dead",
      "encounter_creature_deleted",
      "spell_list_prepared",
      "aps",
      "aps_total",
      "weapon_attack",
      "head_attack",
      "reaction",
      "mana",
      "luck",
      "spirit",
      "hunger_meter_current",
      "thirst_meter_current",
      "x_pos",
      "y_pos",
      "z_pos",
      "movement_pct",
      "preferred_speed_type",
      "encounter_creature_presentation_pic_id",
      "encounter_creature_thumbnail_pic_id",
      "gender",
      "body_appearance",
      "merchant_favor",
      "voice_id",
      "combat_id",
      "lair_dc",
      "appearance",
      "movement_rev"
    ]
  },
  "inventory": {
    "key": "inventory_id",
    "owner": "possess_id",
    "prefix": "inventory",
    "existing_parent": true,
    "required": [
      "inventory_id",
      "possess_id",
      "inventory_item_id",
      "inventory_name",
      "item_qty"
    ],
    "updates": [
      "inventory_deleted",
      "possess_id",
      "equipped",
      "inventory_wares",
      "item_qty",
      "x_pos",
      "y_pos",
      "z_pos"
    ],
    "columns": [
      "inventory_private",
      "inventory_id",
      "inventory_name",
      "inventory_description",
      "inventory_written_in_language",
      "inventory_flavor_text",
      "inventory_gm_notes",
      "inventory_item_id",
      "inventory_cost_gp",
      "possess_id",
      "item_qty",
      "equipped",
      "enchantment_template_id",
      "inventory_unidentified",
      "inventory_wares",
      "inventory_inspection_dc",
      "v_current",
      "v_max",
      "v_temp",
      "v_max_temp",
      "x_pos",
      "y_pos",
      "z_pos",
      "inventory_presentation_pic_id",
      "inventory_thumbnail_pic_id",
      "lockpick_degree_start",
      "lockpick_degree_end",
      "inventory_deleted",
      "inventory_size",
      "weight_override"
    ],
    "numbers": [
      "inventory_private",
      "inventory_unidentified",
      "item_qty",
      "v_current",
      "v_max",
      "v_temp",
      "v_max_temp",
      "x_pos",
      "y_pos",
      "z_pos",
      "inventory_cost_gp",
      "inventory_inspection_dc",
      "lockpick_degree_start",
      "lockpick_degree_end",
      "inventory_wares",
      "inventory_deleted",
      "weight_override"
    ],
    "decimals": [
      "x_pos",
      "y_pos",
      "z_pos",
      "inventory_cost_gp",
      "lockpick_degree_start",
      "lockpick_degree_end",
      "weight_override"
    ]
  },
  "statuses": {
    "key": "status_id",
    "owner": "status_target_id",
    "prefix": "status",
    "required": [
      "status_id",
      "status_target_id",
      "status_caster_id",
      "status_item_id",
      "status_connected_id"
    ],
    "updates": [
      "status_deleted"
    ],
    "columns": [
      "status_private",
      "status_deleted",
      "status_id",
      "status_item_id",
      "status_shapeshift_monster_template_id",
      "status_caster_id",
      "status_target_id",
      "status_casting_targets_arr",
      "status_origin_point_x",
      "status_origin_point_y",
      "status_origin_point_z",
      "status_distance_point_x",
      "status_distance_point_y",
      "status_distance_point_z",
      "status_aoe_type",
      "status_aoe_distance",
      "status_aoe_distance_depth",
      "status_aoe_distance_height",
      "status_aoe_source",
      "status_aoe_geometry",
      "status_opposing_team_only",
      "status_damage_type",
      "status_forced_roll_extreme",
      "status_stack",
      "status_origin_id",
      "status_connected_id",
      "status_campaign_id",
      "status_starts_campaign_year",
      "status_starts_campaign_month",
      "status_starts_campaign_day",
      "status_starts_campaign_hour",
      "status_starts_campaign_minute",
      "status_starts_campaign_second",
      "status_ends_campaign_year",
      "status_ends_campaign_month",
      "status_ends_campaign_day",
      "status_ends_campaign_hour",
      "status_ends_campaign_minute",
      "status_ends_campaign_second",
      "status_ends_on_target_start_of_turn",
      "status_ends_on_target_end_of_turn",
      "status_ends_on_caster_start_of_next_turn",
      "status_ends_on_caster_end_of_next_turn",
      "status_paused_campaign_year",
      "status_paused_campaign_month",
      "status_paused_campaign_day",
      "status_paused_campaign_hour",
      "status_paused_campaign_minute",
      "status_paused_campaign_second"
    ],
    "numbers": [
      "status_private",
      "status_deleted",
      "status_origin_point_x",
      "status_origin_point_y",
      "status_origin_point_z",
      "status_distance_point_x",
      "status_distance_point_y",
      "status_distance_point_z",
      "status_aoe_distance",
      "status_aoe_distance_depth",
      "status_aoe_distance_height",
      "status_aoe_source",
      "status_opposing_team_only",
      "status_forced_roll_extreme",
      "status_stack",
      "status_starts_campaign_year",
      "status_starts_campaign_month",
      "status_starts_campaign_day",
      "status_starts_campaign_hour",
      "status_starts_campaign_minute",
      "status_starts_campaign_second",
      "status_ends_campaign_year",
      "status_ends_campaign_month",
      "status_ends_campaign_day",
      "status_ends_campaign_hour",
      "status_ends_campaign_minute",
      "status_ends_campaign_second",
      "status_ends_on_target_start_of_turn",
      "status_ends_on_target_end_of_turn",
      "status_ends_on_caster_start_of_next_turn",
      "status_ends_on_caster_end_of_next_turn",
      "status_paused_campaign_year",
      "status_paused_campaign_month",
      "status_paused_campaign_day",
      "status_paused_campaign_hour",
      "status_paused_campaign_minute",
      "status_paused_campaign_second"
    ],
    "decimals": [
      "status_origin_point_x",
      "status_origin_point_y",
      "status_origin_point_z",
      "status_distance_point_x",
      "status_distance_point_y",
      "status_distance_point_z",
      "status_aoe_distance",
      "status_aoe_distance_depth",
      "status_aoe_distance_height"
    ],
    "references": [
      "status_caster_id"
    ],
    "before": [
      "status_deleted",
      "status_target_id",
      "status_item_id",
      "status_connected_id"
    ]
  },
  "charges": {
    "operations": ["insert"],
    "key": "charge_id",
    "owner": "charge_holder",
    "prefix": "charge",
    "required": [
      "charge_id",
      "charge_holder",
      "item_id",
      "charges"
    ],
    "updates": [],
    "columns": [
      "charge_private",
      "charge_deleted",
      "charge_id",
      "charge_holder",
      "item_id",
      "charges"
    ],
    "numbers": [
      "charges",
      "charge_private",
      "charge_deleted"
    ]
  },
  "pictures": {
    "operations": ["update"],
    "key": "picture_id",
    "prefix": "picture",
    "owner": "picture_attached_id",
    "columns": [
      "picture_id",
      "picture_attached_id",
      "picture_deleted"
    ],
    "updates": [
      "picture_deleted"
    ],
    "required": [
      "picture_id",
      "picture_attached_id"
    ],
    "numbers": [
      "picture_deleted"
    ]
  },
  "encounter_creatures_spells_prepared": {
    "operations": ["update"],
    "key": "encounter_creature_spell_prepared_i",
    "key_type": "integer",
    "prefix": "encounter_creature_spell_prepared",
    "owner": "encounter_creature_id",
    "columns": [
      "encounter_creature_spell_prepared_i",
      "encounter_creature_id",
      "encounter_creature_spell_prepared_deleted"
    ],
    "updates": [
      "encounter_creature_spell_prepared_deleted"
    ],
    "required": [
      "encounter_creature_spell_prepared_i",
      "encounter_creature_id"
    ],
    "numbers": [
      "encounter_creature_spell_prepared_i",
      "encounter_creature_spell_prepared_deleted"
    ]
  },
  "encounters": {
    "key": "encounter_id",
    "owner": "encounter_id",
    "prefix": "encounter",
    "required": [
      "encounter_id"
    ],
    "operations": [
      "update"
    ],
    "columns": [
      "encounter_id"
    ],
    "updates": [
      "current_encounter_creature_id_turn",
      "current_round",
      "turn_phase",
      "pending_main_turn_encounter_creature_id",
      "legendary_turn_queue"
    ],
    "numbers": [
      "current_round"
    ],
    "references": [
      "current_encounter_creature_id_turn",
      "pending_main_turn_encounter_creature_id"
    ]
  },
  "campaigns": {
    "key": "campaign_id",
    "owner": "campaign_id",
    "prefix": "campaign",
    "required": [
      "campaign_id"
    ],
    "operations": [
      "update"
    ],
    "columns": [
      "campaign_id"
    ],
    "updates": [
      "campaign_time_year",
      "campaign_time_month",
      "campaign_time_day",
      "campaign_time_hour",
      "campaign_time_minute",
      "campaign_time_second"
    ],
    "numbers": [
      "campaign_time_year",
      "campaign_time_month",
      "campaign_time_day",
      "campaign_time_hour",
      "campaign_time_minute",
      "campaign_time_second"
    ]
  },
  "encounter_creature_triggers": {
    "key": "trigger_id",
    "owner": "caster_encounter_creature_id",
    "prefix": "trigger",
    "audit": false,
    "parent_types": ["encounter_creatures"],
    "persisted_values": {"trigger_type": ["counterspell"]},
    "values": {"active": [0, 1]},
    "required": [
      "trigger_id"
    ],
    "operations": [
      "update"
    ],
    "columns": [
      "trigger_id"
    ],
    "updates": [
      "active"
    ],
    "before": [
      "active",
      "caster_encounter_creature_id"
    ],
    "numbers": [
      "active"
    ]
  },
  "cast_inventory": {
    "extends": "inventory",
    "table": "inventory",
    "key": "inventory_id",
    "operations": ["insert"],
    "existing_parent": true,
    "parent_types": ["encounter_creatures"]
  },
  "enchantment_templates": {
    "key": "enchantment_template_id",
    "prefix": "enchantment_template",
    "owner": "spawn_parent_id",
    "parent": true,
    "operations": ["insert"],
    "parent_types": ["encounter_creatures"],
    "required": ["enchantment_template_id", "enchantment_template_name", "spawn_parent_id"],
    "columns": ["enchantment_template_id", "enchantment_template_name", "enchantment_template_private"],
    "context_columns": ["spawn_parent_id"],
    "derived": ["enchantment_template_private"],
    "required_references": ["spawn_parent_id"],
    "updates": [],
    "numbers": ["enchantment_template_private"]
  },
  "enchantment_template_enchantments": {
    "key": "enchantment_id",
    "prefix": "enchantment_template_enchantment",
    "updated_audit": false,
    "owner": "enchantment_template_id",
    "operations": ["insert"],
    "parent_types": ["enchantment_templates"],
    "required": ["enchantment_id", "enchantment_template_id", "enchantment_type", "enchantment_item_id", "enchantment_name"],
    "columns": ["enchantment_id", "enchantment_template_id", "enchantment_type", "enchantment_item_id", "enchantment_name", "enchantment_template_enchantment_private"],
    "derived": ["enchantment_template_enchantment_private"],
    "required_references": ["enchantment_template_id"],
    "updates": [],
    "numbers": ["enchantment_template_enchantment_private"]
  },
  "death_inventory_pictures": {
    "extends": "pictures",
    "table": "pictures",
    "key": "picture_id",
    "parent_types": ["inventory"],
    "before": ["picture_attached_id", "picture_deleted"]
  },
  "death_part_statuses": {
    "extends": "statuses",
    "table": "statuses",
    "key": "status_id",
    "operations": ["insert"],
    "existing_parent": true,
    "parent_types": ["inventory"],
    "parent_source_type": "monster_bit",
    "values": {"status_item_id": ["36C061BF-E480-4334-961C-26500150E3C4"]}
  },
  "death_loot": {
    "extends": "inventory",
    "table": "inventory",
    "key": "inventory_id",
    "operations": ["insert"],
    "existing_parent": true,
    "parent_types": ["encounter_creatures"],
    "source_type": "monster_bit"
  },
  "corpse_inventory": {
    "extends": "inventory",
    "table": "inventory",
    "key": "inventory_id",
    "operations": ["insert"],
    "required": ["inventory_id", "possess_id", "inventory_item_id", "inventory_name", "item_qty", "inventory_encounter_creature_id"],
    "extra_columns": ["inventory_encounter_creature_id"],
    "existing_parent": true,
    "references": ["inventory_encounter_creature_id"],
    "required_references": ["inventory_encounter_creature_id"],
    "reference_types": {"inventory_encounter_creature_id": ["encounter_creatures"]}
  },
  "corpse_links": {
    "table": "inventory_encounter_creature_links",
    "key": "inventory_encounter_creature_link_id",
    "prefix": "inventory_encounter_creature_link",
    "owner": "inventory_encounter_creature_link_inventory_id",
    "operations": ["insert"],
    "required": ["inventory_encounter_creature_link_id", "inventory_encounter_creature_link_inventory_id", "inventory_encounter_creature_link_encounter_creature_id", "inventory_encounter_creature_link_kind"],
    "columns": ["inventory_encounter_creature_link_id", "inventory_encounter_creature_link_inventory_id", "inventory_encounter_creature_link_encounter_creature_id", "inventory_encounter_creature_link_kind", "inventory_encounter_creature_link_source_item_id", "inventory_encounter_creature_link_killer_id", "inventory_encounter_creature_link_died_round", "inventory_encounter_creature_link_notes", "inventory_encounter_creature_link_encounter_id", "inventory_encounter_creature_link_private"],
    "derived": ["inventory_encounter_creature_link_encounter_id", "inventory_encounter_creature_link_private"],
    "updates": [],
    "numbers": ["inventory_encounter_creature_link_died_round", "inventory_encounter_creature_link_private"],
    "values": {"inventory_encounter_creature_link_kind": ["corpse"]},
    "required_references": ["inventory_encounter_creature_link_inventory_id", "inventory_encounter_creature_link_encounter_creature_id"],
    "references": ["inventory_encounter_creature_link_encounter_creature_id", "inventory_encounter_creature_link_killer_id"],
    "reference_types": {"inventory_encounter_creature_link_encounter_creature_id": ["encounter_creatures"], "inventory_encounter_creature_link_killer_id": ["encounter_creatures"]}
  },
  "encounter_inventory": {
    "extends": "inventory",
    "table": "inventory",
    "key": "inventory_id",
    "extra_columns": ["transform_3d"],
    "operations": ["insert"],
    "existing_parent": true,
    "parent_types": ["encounters", "locations"]
  },
  "inventory_lock_bindings": {
    "key": "inventory_lock_binding_id",
    "owner": "inventory_lock_binding_secured_id",
    "prefix": "inventory_lock_binding",
    "operations": ["insert"],
    "required": ["inventory_lock_binding_id", "inventory_lock_binding_lock_id", "inventory_lock_binding_secured_id", "inventory_lock_binding_installation"],
    "columns": ["inventory_lock_binding_id", "inventory_lock_binding_lock_id", "inventory_lock_binding_secured_id", "inventory_lock_binding_installation", "inventory_lock_binding_private", "inventory_lock_binding_deleted"],
    "derived": ["inventory_lock_binding_private", "inventory_lock_binding_deleted"],
    "updates": [],
    "numbers": ["inventory_lock_binding_private", "inventory_lock_binding_deleted"],
    "parent_types": ["inventory"],
    "references": ["inventory_lock_binding_lock_id"],
    "required_references": ["inventory_lock_binding_lock_id", "inventory_lock_binding_secured_id"],
    "reference_types": {"inventory_lock_binding_lock_id": ["inventory"]},
    "reference_source_types": {"inventory_lock_binding_lock_id": "lock"},
    "values": {"inventory_lock_binding_installation": ["padlock", "integrated"]}
  },
  "encounter_creature_swarm_states": {
    "key": "encounter_creature_swarm_state_id",
    "prefix": "encounter_creature_swarm_state",
    "owner": "encounter_creature_swarm_state_encounter_creature_id",
    "parent_types": [
      "encounter_creatures"
    ],
    "existing_parent": true,
    "required": [
      "encounter_creature_swarm_state_id",
      "encounter_creature_swarm_state_encounter_creature_id",
      "encounter_creature_swarm_state_members",
      "encounter_creature_swarm_state_members_start",
      "encounter_creature_swarm_state_shed_total",
      "encounter_creature_swarm_state_revision",
      "encounter_creature_swarm_state_notes"
    ],
    "columns": [
      "encounter_creature_swarm_state_id",
      "encounter_creature_swarm_state_encounter_creature_id",
      "encounter_creature_swarm_state_encounter_id",
      "encounter_creature_swarm_state_members",
      "encounter_creature_swarm_state_members_start",
      "encounter_creature_swarm_state_shed_total",
      "encounter_creature_swarm_state_revision",
      "encounter_creature_swarm_state_notes",
      "encounter_creature_swarm_state_private",
      "encounter_creature_swarm_state_deleted"
    ],
    "derived": [
      "encounter_creature_swarm_state_encounter_id",
      "encounter_creature_swarm_state_private"
    ],
    "updates": [
      "encounter_creature_swarm_state_members",
      "encounter_creature_swarm_state_members_start",
      "encounter_creature_swarm_state_shed_total",
      "encounter_creature_swarm_state_revision",
      "encounter_creature_swarm_state_notes",
      "encounter_creature_swarm_state_deleted"
    ],
    "before": [
      "encounter_creature_swarm_state_revision",
      "encounter_creature_swarm_state_encounter_creature_id",
      "encounter_creature_swarm_state_deleted"
    ],
    "numbers": [
      "encounter_creature_swarm_state_members",
      "encounter_creature_swarm_state_members_start",
      "encounter_creature_swarm_state_shed_total",
      "encounter_creature_swarm_state_revision",
      "encounter_creature_swarm_state_private",
      "encounter_creature_swarm_state_deleted"
    ]
  },
  "swarm_pile_links": {
    "extends": "corpse_links",
    "table": "inventory_encounter_creature_links",
    "key": "inventory_encounter_creature_link_id",
    "required": [
      "inventory_encounter_creature_link_id",
      "inventory_encounter_creature_link_inventory_id",
      "inventory_encounter_creature_link_kind",
      "inventory_encounter_creature_link_source_item_id"
    ],
    "required_references": [
      "inventory_encounter_creature_link_inventory_id"
    ],
    "parent_types": [
      "inventory"
    ],
    "values": {
      "inventory_encounter_creature_link_kind": [
        "swarm_pile"
      ]
    }
  },
  "encounter_creature_turn_resets": {
    "table": "encounter_creatures",
    "key": "encounter_creature_id",
    "owner": "encounter_id",
    "prefix": "encounter_creature",
    "persisted_types": ["creature", "lair", "player_character"],
    "operations": ["update"],
    "required": ["encounter_creature_id"],
    "columns": ["encounter_creature_id"],
    "updates": ["aps", "aps_total", "reaction", "weapon_attack", "head_attack", "movement_pct", "movement_rev"],
    "before": ["movement_rev"],
    "numbers": ["aps", "aps_total", "reaction", "weapon_attack", "head_attack", "movement_pct", "movement_rev"]
  }
}
